import React, { useState, useEffect } from 'react';
import ApiServices from '../../services/ApiServices';
import { useHistory } from 'react-router-dom';
import CollectionTile from './CollectionCard';
import { useLoading } from '../../context/LoadingContext';

export const MyCollections = ({
    onOpenCollection,
    isMyCollections,
    changedUserHasCollections
}) => {

    const [collections, setCollections] = useState([]);
    const [user, setUser] = useState();
    const history = useHistory();

    const { setLoading } = useLoading();

    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true);

                const loggedInUser = localStorage.getItem("user");
                let currentUser = null;

                if (loggedInUser) {
                    currentUser = JSON.parse(loggedInUser);
                    setUser(currentUser);
                }

                const data = await ApiServices.getCollections(
                    isMyCollections,
                    currentUser
                );

                setCollections(data);

                if (changedUserHasCollections) {
                    changedUserHasCollections(data && data.length > 0);
                }
            }
            catch (error) {
                console.error(error);
            }
            finally {
                setLoading(false);
            }
        };

        loadData();
    }, [isMyCollections]);


    return (
        <div className="collectionsGrid">{
            collections.map((collection) => (
                <CollectionTile key={collection.collectionId} collection={collection} cardLayout='vertical' />
            ))
        }</div>
    );
}

export default MyCollections;
